<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card>
                    <div class="name">
                        总设备数量
                    </div>
                    <div class="number">
                        {{ total }}
                    </div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card>
                    <div class="name">
                        已激活数量
                    </div>
                    <div class="number">
                        {{ activeNum }}
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-card class="mt-5">
            <div id="deviceChart" style="width: 100%; height: 400px;"></div>
        </el-card>
        <el-card class="mt-5 relative">
            <div class="flex items-center gap-x-3 absolute top-5 right-5 z-999">
                <el-date-picker v-model="date1" type="daterange" range-separator="~" start-placeholder="开始日期"
                    end-placeholder="结束日期" @change="afterSaleStat"></el-date-picker>
                <el-button-group>
                    <el-button :type="category === '设备' ? 'primary' : ''"
                        @click="handleCategoryChange('设备')">设备</el-button>
                    <el-button :type="category === '配件' ? 'primary' : ''"
                        @click="handleCategoryChange('配件')">配件</el-button>
                </el-button-group>
                <el-button type="primary">导出</el-button>
            </div>
            <div id="statChart" style="width: 100%; height: 400px;"></div>
        </el-card>
        <el-card class="mt-5 relative">
            <div class="flex items-center gap-x-3 absolute top-5 right-5 z-999">
                <el-date-picker v-model="date2" type="monthrange" range-separator="~" start-placeholder="开始月份"
                    end-placeholder="结束月份" @change="deviceActiveTrend"></el-date-picker>
                <CountrySelector v-model="country" @change="deviceActiveTrend"></CountrySelector>
            </div>
            <div id="newChart" style="width: 100%; height: 400px;"></div>
        </el-card>
    </div>
</template>

<script>
import CountrySelector from '@/components/CountrySelector.vue';
import * as echarts from 'echarts';
import { deviceNumStats, afterSaleStat, deviceActiveTrend } from '@/api/statistics/device';
import dayjs from 'dayjs';

const getThisWeek = () => {
    const today = dayjs();
    const dayOfWeek = today.day();
    const monday = today.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'day').format('YYYY-MM-DD 00:00:00');
    const sunday = today.add(dayOfWeek === 0 ? 0 : 7 - dayOfWeek, 'day').format('YYYY-MM-DD 23:59:59');
    return [monday, sunday];
};

export default {
    components: { CountrySelector },
    data() {
        return {
            deviceChart: null,
            statChart: null,
            date1: getThisWeek(),
            date2: [dayjs().format('YYYY-01'), dayjs().format('YYYY-12')],
            category: '设备',
            newChart: null,
            country: '',
            total: 0,
            activeNum: 0
        }
    },
    mounted() {
        this.deviceNumStats();
        this.afterSaleStat();
        this.deviceActiveTrend();
    },
    methods: {
        handleCategoryChange(val) {
            this.category = val;
            this.afterSaleStat();
        },
        deviceNumStats() {
            deviceNumStats().then(({ code, result, message }) => {
                if (code === 200) {
                    this.total = result.total;
                    this.activeNum = result.activeNum;
                    this.initDeviceChart(result.deviceTypeList || []);
                } else {
                    this.$message.error(message);
                }
            });
        },
        deviceActiveTrend() {
            deviceActiveTrend({
                country: this.country,
                startMonth: this.date2[0] ? dayjs(this.date2[0]).format('YYYY-MM') : null,
                endMonth: this.date2[1] ? dayjs(this.date2[1]).format('YYYY-MM') : null
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.initNewChart(result || []);
                } else {
                    this.$message.error(message);
                }
            })
        },
        afterSaleStat() {
            afterSaleStat({
                category: this.category,
                startTime: this.date1[0] ? dayjs(this.date1[0]).format('YYYY-MM-DD 00:00:00') : '',
                endTime: this.date1[1] ? dayjs(this.date1[1]).format('YYYY-MM-DD 23:59:59') : ''
            }).then(({ code, result, message }) => {
                if (code === 200) {
                    this.initStatChart(result || []);
                } else {
                    this.$message.error(message);
                }
            })
        },
        initDeviceChart(_data) {
            const data = _data.map(x => ({ value: x.count, name: x.name }));
            this.deviceChart = echarts.init(document.getElementById('deviceChart'));
            this.deviceChart.setOption({
                title: {
                    text: '设备类型分布'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: 'center',
                    left: 'right',
                    orient: 'vertical'
                },
                series: [
                    {
                        name: '设备类型分布',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: true,
                            // 样式配置
                            color: '#333',
                            fontSize: 14,
                            // 格式化标签
                            formatter: '{d}%',
                            // 标签位置调整
                            alignTo: 'labelLine'
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            });
        },
        initStatChart(data) {
            const xData = data.map(x => x.name);
            const yData = data.map(x => x.count);
            this.statChart = echarts.init(document.getElementById('statChart'));
            this.statChart.setOption({
                title: { text: '售后统计' },
                xAxis: {
                    type: 'category',
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: yData,
                        type: 'bar',
                        barMaxWidth: 50
                    }
                ]
            });
        },
        initNewChart(data) {
            const xData = data.xdata;
            const yData = data.ydata;
            this.newChart = echarts.init(document.getElementById('newChart'));
            this.newChart.setOption({
                title: { text: '新增激活设备趋势' },
                xAxis: {
                    type: 'category',
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: yData,
                        type: 'line',
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(58, 77, 233, 0.8)' },
                                { offset: 1, color: 'rgba(58, 77, 233, 0.1)' }
                            ])
                        },
                        smooth: true
                    }
                ]
            });
        }
    }
}
</script>

<style lang="less" scoped>
.name {
    font-size: 16px;
    color: #999;
}

.number {
    font-size: 24px;
    font-weight: bold;
}
</style>